<!-- Hero Section (Split Layout) -->
<section class="hero-section">
    <div class="container">
        <div class="hero-grid">
            <!-- Main Slider (Left) -->
            @if (bannerDeals.length > 0) {
            <div class="hero-main">
                <div class="slider-display" id="hero-main-display">
                    <div class="slider-track" id="hero-main-track" #sliderTrack (scroll)="onSliderScroll()">
                        @for (deal of bannerDeals; track deal.DealId; let i = $index) {
                        <div class="slide" [attr.data-slide]="deal.StoreName" (click)="directToDealCodePage(deal)">
                            <img [src]="deal.DealImageUrl" [alt]="deal.StoreName" width="850" height="300"
                                [attr.fetchpriority]="i === 0 ? 'high' : 'low'"
                                [attr.loading]="i === 0 ? 'eager' : 'lazy'" decoding="async">
                        </div>
                        }
                    </div>
                    <!-- Brand Navigation Tabs (Moved Inside for Overlay) -->
                    <div class="hero-brand-tabs">
                        @for (deal of bannerDeals; track deal.DealId; let i = $index) {
                        <div class="brand-tab" [class.active]="i === activeSlide" data-brand="deal.StoreName"
                            (click)="selectSlide(i); $event.stopPropagation()">{{ deal.StoreName }}</div>
                        }
                    </div>
                </div>
            </div>
            }
            <!-- Side Banner (Right) -->
            @if (categories && categories.length > 1) {
            <div class="hero-side">
                <div class="side-slider-wrapper" id="hero-side-display">
                    <div class="slider-track" id="hero-side-track-angular" #sideSliderTrack
                        (scroll)="onSideSliderScroll()">
                        @for (category of categories; track $index) {
                        <div class="slide" [attr.data-side]="category.CategoryName"
                            (click)="directToCategoryPageCoupons(category)">
                            <img [src]="category.ImageUrl" [alt]="category.CategoryName" width="600" height="400"
                                loading="lazy" decoding="async">
                        </div>
                        }
                    </div>
                    <!-- Side Brand Tabs -->
                    <div class="side-brand-tabs">
                        @for (category of categories; track $index) {
                        <div class="side-tab" [class.active]="activeSideSlide === $index"
                            [attr.data-side]="category.CategoryName" (click)="selectSideSlide($index)">
                            {{ category.CategoryName }}
                        </div>
                        }
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</section>

<!-- Top Coupons Section -->
<section class="section bg-light home-coupons-section" *ngIf="(homeCoupons && homeCoupons.length) || !isDataLoaded">
    <div class="container">
        <div class="section-header">
            <h1>Latest Best Offers, Coupons & Promo Codes</h1>
        </div>
        <div class="coupons-grid">
            <!-- Coupon Card -->
            <div class="tc-card" *ngFor="let coupon of homeCoupons">
                <div class="tc-card-top">
                    <div class="tc-badge">
                        <span class="tc-b-top" *ngIf="coupon.OfferTitle != ''">{{coupon.OfferTitle}}</span>
                        <span class="tc-b-main"
                            *ngIf="coupon.CoupounOfferTitle != ''">{{coupon.CoupounOfferTitle!.split(' ')[0]}}</span>
                        <span class="tc-b-bot"
                            *ngIf="coupon.CoupounOfferTitle != ''">{{coupon.CoupounOfferTitle!.split(' ')[1]}}</span>
                    </div>
                    <div class="tc-v-dash"></div>
                    <div class="tc-card-body">
                        <div class="tc-meta-row">
                            <span class="tc-meta-item tc-verified"><img src="images/verified-icon.svg" alt="Verified"
                                    width="14" height="14"> Verified</span>
                            <span class="tc-meta-item tc-users" *ngIf="coupon.CouponClickCount > 0">
                                <img src="images/users-icon.svg" alt="Click Count" width="14" height="14">
                                {{ coupon.CouponClickCount }} {{ coupon.CouponClickCount === 1 ? 'Use' : 'Uses' }}
                            </span>
                        </div>
                        <h3 class="tc-card-title">{{coupon.CouponTitle!}}</h3>
                        <div class="tc-expiry-row">
                            <img src="images/clock-icon.svg" alt="Valid Till" width="13" height="13"> Valid Till:
                            {{!coupon.CouponEndDate ? 'On Going' : coupon.CouponEndDate | date: 'MMM dd, yyyy'}}
                        </div>
                    </div>
                </div>
                <div class="tc-card-footer">
                    <div class="tc-brand-wrap" (click)="directToBrandPage(coupon)">
                        <img [src]="coupon.StoreLogo" alt="{{coupon.SeoName}} Logo" class="tc-brand-img" width="65"
                            height="32" loading="lazy">
                    </div>
                    <div (click)="directToCouponPage(coupon)" class="tc-get-offer-btn cursor-pointer">
                        <span>Get Offer Now</span>
                        <span class="tc-arrow-circle">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Popular Offers -->
<section class="section bg-white home-deals-section" *ngIf="(topDeals && topDeals.length > 0) || !isDataLoaded">
    <div class="container">
        <div class="section-header">
            <h2>Deals of the Day - {{ today | date:'dd MMM yyyy' }}</h2>
            <a href="/deals/" class="view-all-link">All Deals &rsaquo;</a>
        </div>
        <div class="offers-grid">
            <!-- Offer Card -->
            <div class="deals-card" *ngFor="let deal of topDeals">
                <div class="deals-card-body">
                    <div class="deals-card-main">
                        <div class="deal-verified"><img src="images/verified-icon.svg" alt="Verified" width="14"
                                height="14" class="deal-icon">
                            <span>Verified</span>
                        </div>
                        <h3 class="deals-card-title">{{deal.DealTitle}}</h3>
                        <div class="deals-card-price">
                            <span class="deal-current-price">{{deal.DealFinalPrice}}</span>
                            <span class="deal-old-price">{{deal.DealListPrice}}</span>
                        </div>
                        <div class="deal-uses"><img src="images/users-icon.svg" alt="Uses Today" width="14" height="14"
                                class="deal-icon">
                            <span>{{deal.DealClickCount}} Uses</span>
                        </div>
                    </div>
                    <div class="deals-card-thumb">
                        <img src="{{deal.DealImageUrl ? deal.DealImageUrl : 'https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&q=80&w=400'}}"
                            alt="{{deal.DealTitle}}" width="95" height="95" loading="lazy">
                    </div>
                </div>
                <div class="deals-card-footer">
                    <div class="offer-brand-wrap" (click)="directToBrandPage(deal)">
                        <img src="{{deal.StoreLogo}}" alt="{{deal.StoreName}} Logo" class="offer-brand-img" width="65"
                            height="32" loading="lazy">
                    </div>
                    <span class="deals-card-link cursor-pointer" (click)="directToDealCodePage(deal)">
                        <span>Get Offer Now</span>
                        <img src="images/arrow-right-icon.svg" alt="Arrow" width="14" height="14"
                            class="deals-link-icon">
                    </span>
                </div>
            </div>
        </div>

        <!-- Mobile Slider Indicator Pills (2 cards per slide, 3 slides) -->
        <div class="offers-slider-pills" id="offers-slider-pills">
            <span class="pill-bar active" data-slide="0"></span>
            <span class="pill-bar" data-slide="1"></span>
            <span class="pill-bar" data-slide="2"></span>
        </div>
    </div>
</section>

<!-- Popular Stores -->
<section class="section bg-white" *ngIf="this.brands && this.brands.length > 0">
    <div class="container">
        <div class="section-header">
            <h2>Popular Stores</h2>
        </div>
        <div class="categories-grid">
            <a *ngFor="let store of brands" href="{{store.SeoName}}-coupons/"
                class="category-item">{{store.StoreName}}</a>
        </div>
    </div>
</section>

<!-- Trending Blog -->
<section class="section bg-light" *ngIf="this.blogs && this.blogs.length > 0">
    <div class="container">
        <div class="section-header">
            <h2>Trending Blog</h2>
        </div>
        <div class="categories-grid">
            <a *ngFor="let blog of blogs" href="{{blog.BlogUrl}}" class="category-item">{{blog.BlogTitle}}</a>
        </div>
    </div>
</section>

<!-- Popular Categories -->
<!-- <section class="section bg-light" *ngIf="categories && categories.length">
    <div class="container">
        <div class="section-header">
            <h2>Popular Categories</h2>
        </div>
        <div class="categories-grid">
            <a *ngFor="let category of categories" href="/coupons/{{category.CategorySEOName}}/"
                class="category-item">{{category.CategoryName}}</a>
        </div>
    </div>
</section> -->

<!-- FAQ Section -->
<section class="section bg-white">
    <div class="container">
        <div class="faq-grid">
            <div class="faq-left">
                <h2 class="faq-heading">Your trusted destination for <span>verified deals</span> and genuine
                    savings.</h2>
                <p class="faq-subtitle">Explore thousands of coupons, promo codes, and deals — verified by our team
                    and updated daily.</p>
                <a href="/deals/" class="faq-cta">Browse All Deals <span>&rarr;</span></a>
            </div>
            <div class="faq-right" (click)="onFaqClick($event)" [innerHTML]="faqHtmlContent | replaceMetaDate: today">
            </div>
        </div>
    </div>
</section>